var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wl-provinces-cascader" },
    [
      _c(
        "el-cascader",
        _vm._b(
          {
            attrs: {
              disabled: _vm.disabled,
              options: _vm.cascaderOptions,
              filterable: "",
              "popper-class": "wl-provinces-cascader-popper",
            },
            model: {
              value: _vm.cascaderVal,
              callback: function ($$v) {
                _vm.cascaderVal = $$v
              },
              expression: "cascaderVal",
            },
          },
          "el-cascader",
          _vm.bind,
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }